// export const SERVER_API_LINK = 'https://rightmed-demo2.herokuapp.com/graphql';
// export const SERVER_LINK = 'https://rightmed-demo2.herokuapp.com';
// export const BYWORK = 'Trilionz';
//strapi.rightmed.ps/graphql
export const SERVER_API_LINK = 'https://strapi.rightmed.ps/graphql';
export const SERVER_LINK = 'https://strapi.rightmed.ps';
export const BYWORK = 'RightMed ';
